<ng-container *ngIf="stormFeatures.length > 0">
    <eaglei-filter-container [filters]="[filter]" (filterChange)="selectStorm($event)"></eaglei-filter-container>
</ng-container>
